import httpClient from "./httpClient";

export const slugifyApi = {
    get(text) {
        return httpClient.get(`slugify?text=${encodeURIComponent(text || '')}`);
    }
}
